import * as React from 'react';
import Select from '../../Misc/Forms/Inputs/Select/Select';
import S from './SortByDropdown.styles';
const SortByDropdown = (props) => {
    return (React.createElement(S.Container, { "data-type": props.type },
        React.createElement(S.Label, { htmlFor: "sort-by-dropdown" }, props.translations?.['global.listings.sortby']),
        React.createElement(Select, { id: "sort-by-dropdown", onChange: (event) => {
                props.onChange(event.target.value);
            } }, props.options.map((option) => (React.createElement("option", { key: option.id, value: option.value, selected: props.value === option.value }, option.label))))));
};
export default SortByDropdown;
